import React, { Component } from 'react'
import cs from 'classnames';
import css from './index.css';
import moment from 'moment';
import { BrokerMessageLoads, BrokerMessage, BidMessage, CarrierVerification, BookingRequestAccept,TrackingInfo, BidAwardMessage, BidExpiredMessage } from './compontents/MessageCard';
import { subTypes } from '../../uilts';
import { userDispatcher } from '~/misc/userAccount'
const MessageCard = ({data, deleteMessage, showRC, goto}) => {
  const {mainType,subType} = data;
  const type = `${mainType}_${subType}`
  switch(type){
    case subTypes.BROKER_MESSAGE:
      return <BrokerMessage
            title={data.title}
            message={data.params.msg}
            time={data.createdAt}
            deleteMessage = {deleteMessage}
          />;
    case subTypes.BROKER_OFFER: 
      return <BrokerMessageLoads
              time={data.createdAt}
              origin={data.params.from}
              dest={data.params.to}
              pickup={data.params.fromDate}
              delivery={data.params.toDate}
              rate={data.params.rate}
              price={data.params.price}
              deleteMessage = {deleteMessage}
              goto={()=>window.open( `/loads/${data.params.shipmentId}`,'_self')}
            />
    case subTypes.BID_REPLY:
      return <BidMessage
              time={data.createdAt}
              title={data.title}
              content={data.body}
              deleteMessage = {deleteMessage}
              goto={()=>goto(`/my-loads?id=bid-${data.params.shipmentId}`)}
            />
    case subTypes.BID_AWARD:
      return <BidAwardMessage
              time={data.createdAt}
              title={data.title}
              content={data.params.styleBody}
              deleteMessage = {deleteMessage}
              goto={()=>goto(`/my-loads?id=bid-${data.params.shipmentId}`)}
            />
    
    case subTypes.BID_EXPIRE:
      return <BidExpiredMessage
              time={data.createdAt}
              title={data.title}
              content={data.body}
              deleteMessage = {deleteMessage}
              goto={()=>goto(`/my-loads?id=bid-${data.params.shipmentId}`)}
            />
    
    case subTypes.VERIFY_RESULT:
      return <CarrierVerification
              time={data.createdAt}
              title={data.title}
              content={data.body}
              deleteMessage = {deleteMessage}
              goto={()=>goto(`${userDispatcher()}/dot-verify`)}
            />
    case subTypes.BOOK_REPLY: 
      return <BookingRequestAccept
              time={data.createdAt}
              title={data.title}
              content={data.body}
              params={data.params}
              deleteMessage = {deleteMessage}
              showRC={showRC}
              goto={()=>goto(`/my-loads?id=booking-${data.params.shipmentId}`)}
            />
    case subTypes.BOOK_LOADSMART: 
      return <BookingRequestAccept
              time={data.createdAt}
              title={data.title}
              content={data.body}
              params={data.params}
              deleteMessage = {deleteMessage}
              showRC={showRC}
              goto={()=>goto(`/my-loads?id=booking-${data.params.shipmentId}`)}
            />
    case subTypes.TRACKING_UPDATE: 
      return <TrackingInfo
              time={data.createdAt}
              title={data.title}
              content={data.params}
              deleteMessage = {deleteMessage}
            />
    case subTypes.VERIFY_LOADSMART: 
      return <CarrierVerification
        time={data.createdAt}
        title={data.title}
        content={data.body}
        deleteMessage = {deleteMessage}
        goto={()=>goto(`${userDispatcher()}/dot-verify`)}
      />
    default:
      return <div></div>
  }
}
class MessagePanel extends Component {
  constructor(props){
    super(props);
  }
  
  render() {
    const { type, title,messages } = this.props;
    if(!type) return (
      <div className={css.empty}>
        <div className={css.emptyIcon}>
        </div>
      </div>
    )
    return (
      <div className={css.warp}>
        <div className={css.title}>
          {title}
        </div>
        <div className={css.content}>
          {messages.data.map(data=>
            (<MessageCard
              deleteMessage={()=>this.props.deleteMessage(data.id, data.mainType)}
              showRC={this.props.showRC}
              data={data}
              goto={this.props.goto}
            ></MessageCard>)
          )}
        </div>
      </div>
    )
  }
}

export default MessagePanel




// WEBPACK FOOTER //
// ./src/pages/MessagePush/compontents/MessagePanel/index.js